const rootComponent = { template: '<ui-view></ui-view>' }

export default rootComponent
